<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    智能消防
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
  },
};
</script>

<style scoped>
</style>
